// Central API configuration.
// Falls back to the known working backend if the env var is missing or empty.
const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  'https://headit-api-mkfk.onrender.com';

export const API_URL = `${BACKEND_URL}/api`;
